// AUTH
export const LOCAL_STORAGE = {
  TOKEN: "token",
  REFRESH_TOKEN: "refresh_token",
  USER_ID: "user_id",
  USER: "user",
  BUSINESS: "business",
  // UI language ("id" | "en"); survives logout on purpose, unlike the auth keys.
  LANGUAGE: "language",
};

export const PAGE_SIZE = 10;

export const MEDIUM_WINDOW_WIDTH = 1325;
export const SMALL_WINDOW_WIDTH = 800;
